import type {
  SearchCitiesQuery as SearchCitiesQueryInput,
  SearchCitiesResponse,
} from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { createQuery } from '~/shared/api'

import { mapCityFromApi } from './mappers/mapCityFromApi'
import type { City } from '../types'

/** GET /cities?q= — поиск города рождения (шторка A2 · город). */
export const SearchCitiesQuery = createQuery<SearchCitiesQueryInput, SearchCitiesResponse, City[]>({
  key: 'user.cities',
  path: API_PATHS.city.search,
  transform: (dto) => dto.items.map(mapCityFromApi),
  cacheBehavior: 'persistent',
})
